import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import bannerImage from '../assets/img/banner-bg.jpg';
import Navbar from './Navbar'; // Import the Navbar component
import AboutWhy from './AboutWhy';
import ThermographyBenefits from './ThermographyBenefits';
import ConsultationSection from './ConsultationSection';
import FooterSection from './FooterSection';

const WhyBanner = () => {
  return (
    <>
      <Navbar />
      <section
        className="why-banner d-flex justify-content-center align-items-center text-center"
        style={{
          backgroundImage: `url(${bannerImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '500px',
          color: '#fff',
        }}
      >
        <div className="container">
          <h1 className="display-4 fw-bold text-black text-start">A Safe, Painless & <br/> Radiation-Free Breast <br/>Health Screening</h1>
          <p className="fs-5 text-black text-start">
          Early detection matters—discover why Breast Infrared is the <br/> future of proactive breast care.
          </p>
          <div className="d-flex justify-content-start">
  <button className="btn gradient-btn">Learn More ➜</button>
</div>

        </div>
      </section>
      <AboutWhy />
      <ThermographyBenefits />
      <ConsultationSection />
      <FooterSection />
    </>
  );
};

export default WhyBanner;
